// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import translate from "@insite/client-framework/Translate";
import { Link } from "@insite/mobius/index";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { parseBoolean } from "@steiner/XDL/Utilities";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: CustomAppState) => {
    const carouselId = state.xProductDetails.substituteProductsCarouselId;
    return {
        isTabletScreen: state.xCommon.isTabletScreen,
        substituteProductsLength: getProductsForProductInfoList(state, carouselId as string)?.length || 0,
        stickyHeaderHeight: state.xHeader.stickyHeaderHeight,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

export interface SubstituteProductsLinkStyle {
    link?: LinkPresentationProps;
}

export const substituteProductsLinkStyle: SubstituteProductsLinkStyle = {};

const styles = substituteProductsLinkStyle;

const SubstituteProductsLink: React.FC<Props> = ({
    isTabletScreen,
    substituteProductsLength,
    stickyHeaderHeight,
}) => {
    if (!substituteProductsLength) {
        return null;
    }

    const handleClick = () => {
        if (typeof document !== "undefined") {
            const element = isTabletScreen
                ? document.querySelector(".substituteProductsAccordion > dt > button")
                : document.getElementById("substitute-products-tab")
                ;

            if (element) {
                if (isTabletScreen) {
                    const yPosition = element.getBoundingClientRect().top + window.pageYOffset - (stickyHeaderHeight ?? 70) - 48;
                    window.scrollTo({ top: yPosition, behavior: "smooth" });
                    if (element?.ariaExpanded && !parseBoolean(element.ariaExpanded)) {
                        (element as HTMLElement).click();
                    }
                } else {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    (element as HTMLElement).click();
                }
            }
        }
    };

    return (
        <Link {...styles.link} onClick={handleClick}>
            {translate("Substitute Products")}
        </Link>
    );
};

export default connect(mapStateToProps)(SubstituteProductsLink);
